import React from 'react'
import { Link } from 'react-router-dom'
import Rating from '@mui/material/Rating'
import AI from '../Image/AI.webp'
import ML from '../Image/ML.webp'
import WD from '../Image/WD.webp'
import DS from '../Image/DS.webp'
import { BsArrowUpRight } from 'react-icons/bs'

function Popular_cource() {
  const courses = [
    {
      title: 'Artificial Intelligence',
      description:
        'Get started on an exciting new adventure in AI with our all-encompassing training program. This course will...',
      imageUrl: AI,
      rating: 4.5,
      link: '/Artificial-Intelligence',
      alt: 'Artificial-Intelligence',
    },
    {
      title: 'ML With Python',
      description:
        'With our course, take a thorough exploration of the field of machine learning with python. Explore both supervised and...',
      imageUrl: ML,
      rating: 4.5,
      link: '/Machine-Learning-With-Python',
      alt: 'Machine-Learning-With-Python',
    },
    {
      title: 'Web Development',
      description:
        'With our course on HTML, CSS, Bootstrap, JavaScript, OOP, DOM manipulation, jQuery, Node.js, and...',
      imageUrl: WD,
      rating: 4.3,
      link: '/Web-Development',
      alt: 'Web-Development',
    },
    {
      title: 'Data Science',
      description:
        'In this course on data science, you will take a deep dive into data collection methods, learn the fundamentals of...',
      imageUrl: DS,
      rating: 4.6,
      link: '/Data-Science',
      alt: 'Data-Science',
    },
  ]
  
  return (
    <>
    <style>{`
      .Popular_cource_text h1{
      color:#2b1c50;
      font-family:"Poppins", sans-serif;
      font-size:1.4 rem;
      user-select: none;
      }
      .Popular_cource_text h2{
      color:#2b1c50;
      font-family:"Poppins", sans-serif;
      font-size:1.4 rem;
      user-select: none;
      }
      .Popular_cource_text p{
      font-size:13px;
      color: var(--color-grey-darken-2);
      font-family:"Poppins", sans-serif;
      user-select: none;
      }
      .Popular_cource_button{
      border: 2px solid;
      border-color:#565add;
      border-radius:10px;
      color: #000;
      background-color:white;
      font-family: 'Poppins', sans-serif;
      font-size:15px;
      }
      .Popular_cource_button:hover{
      color:white;
      border-radius:10px;
      background-color:#565add;
      font-family: 'Poppins', sans-serif;
      }
      .Program_link{
      text-decoration:none !important;
      color: #000;
      }
    `}</style>
    <div>
      <div className="container-fluid Popular_cource_text px-4 mt-4">
        <h2> Our Trending Program</h2>
        <p className="pt-2">
          Join our renowned Programs: the knowledge provided will surely be invaluable to you!
        </p>
      </div>

      {/* ---------------------------Desktop View----------------------- */}
      <div className="d-none d-xl-block">
        <div className="container">
          <div className="row">
            {courses.map((course, index) => (
              <div className="col-md-3" key={index}>
                <Link className="Program_card_link" to={course.link}>
                  <div className="border Program_link shadow-sm Program_card pb-1">
                    <div className="p-3">
                      <img
                        className="border rounded"
                        src={course.imageUrl}
                        alt={course.alt}
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="px-3">
                      <div className="row">
                        <div className="col-md-10">
                          <h2 className="pt-2">{course.title}</h2>
                        </div>
                        <div className="col-md-2">
                          <BsArrowUpRight className="text-end" />
                        </div>
                        <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                        <b>Duration:</b> 2 Months
                      </h6>
                      {/* <h5 className="fw-normal pt-2">
                        {course.rating}{' '}
                        <Rating
                          name={`rating-${index}`}
                          size="small"
                          defaultValue={course.rating}
                          precision={0.1}
                          readOnly
                        />
                      </h5> */}
                      
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ------------------Tab View-------------------- */}
      <div className="container d-none d-md-block d-xl-none">
        <div className="row">
          {courses.map((course, index) => (
            <div className="col-md-3" key={index}>
              <Link className="Program_card_link" to={course.link}>
                <div className="border Program_link shadow tab_Program_card pb-1">
                  <div>
                    <img
                      className="p-2"
                      src={course.imageUrl}
                      alt={course.alt}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  </div>
                  <div className="px-3 tab_Program_card">
                    <div className="row">
                      <div className="col-md-10">
                        <h2 className="">{course.title}</h2>
                      </div>
                      <div className="col-md-2">
                        <BsArrowUpRight className="text-end" />
                      </div>
                      <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                      <b>Duration:</b> 2 Months
                      </h6>
                      {/* <h5 className="fw-normal pt-2">
                        {course.rating}{' '}
                        <Rating
                          name={`rating-${index}`}
                          size="small"
                          defaultValue={course.rating}
                          precision={0.1}
                          readOnly
                        />
                      </h5> */}
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* ------------------mobile View-------------------- */}
      <div className="container d-sm-block d-md-none">
        <div className="row">
          {courses.map((course, index) => (
            <div className="col-12 px-4" key={index}>
              <Link className="Program_card_link" to={course.link}>
                <div className="border Program_link pb-2 shadow Program_mobile_card">
                  <div>
                    <img
                      className="p-2"
                      src={course.imageUrl}
                      alt={course.alt}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  </div>
                  <div className="px-3">
                    <div className="row">
                      <div className="col-10">
                        <h2 className="pt-2">{course.title}</h2>
                      </div>
                      <div className="col-2">
                        <BsArrowUpRight className="text-end" />
                      </div>
                      <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                      <b>Duration:</b> 2 Months
                      </h6>
                      {/* <h5 className="fw-normal pt-2">
                        {course.rating}{' '}
                        <Rating
                          name={`rating-${index}`}
                          size="small"
                          defaultValue={course.rating}
                          precision={0.1}
                          readOnly
                        />
                      </h5> */}
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  )
}

export default Popular_cource
